import { getTrainingStyles } from "../_training.styles";

export const IconContainer = ({ children }: { children: React.ReactNode }) => {
  const { classes } = getTrainingStyles();

  return <div className={classes.cardIconContainer}>{children}</div>;
};
